/**************************************************
 * Nombre:       Home_Refistra_Correo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BarraCorreo from "./SubComponentes/BarraCorreo";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Refistra_Correo = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{background: 'linear-gradient(180deg, #91DDCF 0%, rgba(255, 255, 255, 0.00) 100%)'}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 10, pb: 16}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography
                                sx={{fontSize: sCell ? 32 : 64, fontWeight: 800, textAlign: 'center', lineHeight: 1.2}}>Regístrate
                                y recibe el 15%
                                de descuento</Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 4}}>
                            <Typography sx={{fontSize: sCell ? 18 : 24, fontWeight: 400, color: '#00092980', textAlign: 'center'}}>
                                15% de descuento en tu primera compra. Entérate de lanzamientos, ofertas, kit de
                                productos.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <BarraCorreo difiere={true}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <Typography sx={{color: '#73808E', textAlign: 'center'}}>
                                Al registrarte aceptas el tratamiento de tus datos. Lea detenidamente
                                <br/>
                                <span style={{color: '#91DDCF'}}>la Política de Privacidad</span>
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Refistra_Correo  